import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';

const getAssigneeList = () => {
    return network.post('api/bo/getAsigneList').then((response) => response.data);
};
export const useQueryAssigneeList = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['assigneeList'],
        queryFn: () => getAssigneeList(),
    });
};

interface QueryResponse {
    firstName: string;
    id: null;
    lastName: string;
    userName: string;
}
